export class CpfDivergenteOtpGeradoException extends Error {}
